import * as api from '../api/global';
import { makeApiActionCreatorV3 } from '@actions/utils';

export const START = 'START';
export const SUCCESS = 'SUCCESS';
export const ERROR = 'ERROR';

export function createRequestTypes(base) {
  return [START, SUCCESS, ERROR].reduce((acc, type) => {
    acc[type] = `${base}_${type}`;
    return acc;
  }, {});
}

export const SELECT_ASSIGNMENT_PATH = 'APPRAISAL/SELECT_ASSIGNMENT_PATH';
export const TOGGLE_MENU = 'APPRAISAL/TOGGLE_MENU';
export const SELECT_YEAR = 'APPRAISAL/SELECT_YEAR';
export const SELECT_OWNER_RECORD = 'APPRAISAL/SELECT_OWNER_RECORD';
export const SELECT_AGENT_RECORD = 'APPRAISAL/SELECT_AGENT_RECORD';
export const SELECT_DEED_RECORD = 'APPRAISAL/SELECT_DEED_RECORD';
export const SET_VIEW_ONLY_MODE = 'APPRAISAL/SET_VIEW_ONLY_MODE';
export const SELECT_PROPERTY_RECORD = 'APPRAISAL/SELECT_PROPERTY_RECORD';
export const SELECT_PROPERTY_RECORD_YEAR =
  'APPRAISAL/SELECT_PROPERTY_RECORD_YEAR';
export const SELECT_PROPERTY_RECORD_DETAILS =
  'APPRAISAL/SELECT_PROPERTY_RECORD_DETAILS';
export const SELECT_MORTGAGELENDER_RECORD =
  'APPRAISAL/SELECT_MORTGAGELENDER_RECORD';
export const SELECT_WEBPAGE_RECORD = 'APPRAISAL/SELECT_WEBPAGE_RECORD';
export const SELECT_SUBCOMPONENT_RECORD =
  'APPRAISAL/SELECT_SUBCOMPONENT_RECORD';
export const SELECT_MENUPROFILE_RECORD = 'APPRAISAL/SELECT_MENUPROFILE_RECORD';
export const SELECT_SMART_GROUP_RECORD = 'APPRAISAL/SELECT_SMART_GROUP_RECORD';
export const SELECT_BUILDER_PLAN_RECORD =
  'APPRAISAL/SELECT_BUILDER_PLAN_RECORD';
export const SELECT_ECONOMIC_UNIT_RECORD =
  'APPRAISAL/SELECT_ECONOMIC_UNIT_RECORD';
export const SELECT_ECONOMIC_UNIT_RECORD_DETAILS =
  'APPRAISAL/SELECT_ECONOMIC_UNIT_RECORD_DETAILS';

export const PREFERENCE_FETCH_START = 'APPRAISAL/PREFERENCE_FETCH_START';
export const PREFERENCE_FETCH_SUCCESS = 'APPRAISAL/PREFERENCE_FETCH_SUCCESS';
export const PREFERENCE_FETCH_ERROR = 'APPRAISAL/PREFERENCE_FETCH_ERROR';

export const PREFERENCE_PERSIST_START = 'APPRAISAL/PREFERENCE_PERSIST_START';
export const PREFERENCE_PERSIST_SUCCESS =
  'APPRAISAL/PREFERENCE_PERSIST_SUCCESS';
export const PREFERENCE_PERSIST_ERROR = 'APPRAISAL/PREFERENCE_PERSIST_ERROR';

export const SET_SIDEBAR_MENU = 'GLOBAL/SET_SIDEBAR_MENU';

export const PROPERTYTYPES_FETCH = createRequestTypes('PROPERTYTYPES_FETCH');
export const ROLES_FETCH = createRequestTypes('ROLES_FETCH');
export const CURRENT_APPRAISAL_YEAR_FETCH = createRequestTypes(
  'GLOBAL/CURRENT_APPRAISAL_YEAR_FETCH',
);

export const APPRAISAL_YEARS_FETCH = createRequestTypes(
  'GLOBAL/APPRAISAL_YEARS_FETCH',
);

export const APPRAISAL_YEARS_STATUS_FETCH = createRequestTypes(
  'GLOBAL/APPRAISAL_YEARS_STATUS_FETCH',
);

export const APPRAISERS_FETCH = createRequestTypes('GLOBAL/APPRAISERS_FETCH');

export const SET_QUICK_SEARCH_FLAG = 'SET_QUICK_SEARCH_FLAG';

export const fetchPreference = makeApiActionCreatorV3(
  api.fetchPreference,
  PREFERENCE_FETCH_START,
  PREFERENCE_FETCH_SUCCESS,
  PREFERENCE_FETCH_ERROR,
);
export const persistPreference = makeApiActionCreatorV3(
  api.persistPreference,
  PREFERENCE_PERSIST_START,
  PREFERENCE_PERSIST_SUCCESS,
  PREFERENCE_PERSIST_ERROR,
);

export const fetchPropertyTypes = makeApiActionCreatorV3(
  api.fetchPropertyTypes,
  PROPERTYTYPES_FETCH[START],
  PROPERTYTYPES_FETCH[SUCCESS],
  PROPERTYTYPES_FETCH[ERROR],
);
export const fetchRoles = makeApiActionCreatorV3(
  api.fetchRoles,
  ROLES_FETCH[START],
  ROLES_FETCH[SUCCESS],
  ROLES_FETCH[ERROR],
);

export const fetchCurrentAppraisalYear = makeApiActionCreatorV3(
  api.fetchSystemAppraisalYear,
  CURRENT_APPRAISAL_YEAR_FETCH[START],
  CURRENT_APPRAISAL_YEAR_FETCH[SUCCESS],
  CURRENT_APPRAISAL_YEAR_FETCH[ERROR],
);

export const fetchAppraisalYears = makeApiActionCreatorV3(
  api.fetchAppraisalYears,
  APPRAISAL_YEARS_FETCH[START],
  APPRAISAL_YEARS_FETCH[SUCCESS],
  APPRAISAL_YEARS_FETCH[ERROR],
);

export const fetchAppraisalYearsWithStatus = makeApiActionCreatorV3(
  api.fetchAppraisalYearsWithStatus,
  APPRAISAL_YEARS_STATUS_FETCH[START],
  APPRAISAL_YEARS_STATUS_FETCH[SUCCESS],
  APPRAISAL_YEARS_STATUS_FETCH[ERROR],
);

export const fetchAppraisers = makeApiActionCreatorV3(
  api.fetchAppraisers,
  APPRAISERS_FETCH[START],
  APPRAISERS_FETCH[SUCCESS],
  APPRAISERS_FETCH[ERROR],
);

export function selectYear(year) {
  return async dispatch => {
    dispatch({ type: SELECT_YEAR, data: year });
  };
}

export function selectOwnerRecord(ownerId) {
  return async dispatch => {
    dispatch({ type: SELECT_OWNER_RECORD, data: ownerId.toString() });
  };
}

export function selectAgentRecord(agentId) {
  return async dispatch => {
    dispatch({ type: SELECT_AGENT_RECORD, data: agentId.toString() });
  };
}

export function selectWebpageRecord(webpageId) {
  return async dispatch => {
    dispatch({ type: SELECT_WEBPAGE_RECORD, data: webpageId.toString() });
  };
}

export function selectSubcomponentRecord(subcomponentId) {
  return async dispatch => {
    dispatch({
      type: SELECT_SUBCOMPONENT_RECORD,
      data: subcomponentId.toString(),
    });
  };
}

export function selectMenuprofileRecord(menuprofileId) {
  return async dispatch => {
    dispatch({
      type: SELECT_MENUPROFILE_RECORD,
      data: menuprofileId.toString(),
    });
  };
}

export function selectDeedRecord(deedId) {
  return async dispatch => {
    dispatch({ type: SELECT_DEED_RECORD, data: deedId.toString() });
  };
}

export function setViewOnlyMode(data) {
  return async dispatch => {
    dispatch({ type: SET_VIEW_ONLY_MODE, data: data });
  };
}

export function selectPropertyRecord(propertyId) {
  return async dispatch => {
    dispatch({ type: SELECT_PROPERTY_RECORD, data: propertyId.toString() });
  };
}

export function setQuickSearchFlag() {
  return async dispatch => {
    dispatch({ type: SET_QUICK_SEARCH_FLAG });
  };
}

export function selectPropertyRecordYear(pYear) {
  return async dispatch => {
    dispatch({ type: SELECT_PROPERTY_RECORD_YEAR, data: pYear.toString() });
  };
}

export function selectPropertyRecordDetails({ pVersion, pRollCorr }) {
  return {
    type: SELECT_PROPERTY_RECORD_DETAILS,
    data: { pVersion, pRollCorr },
  };
}

export function selectMortgagelenderRecord(mortgagelenderId) {
  return async dispatch => {
    dispatch({
      type: SELECT_MORTGAGELENDER_RECORD,
      data: mortgagelenderId.toString(),
    });
  };
}

export function selectSmartGroupRecord(groupId) {
  return async dispatch => {
    dispatch({
      type: SELECT_SMART_GROUP_RECORD,
      data: groupId.toString(),
    });
  };
}

export function selectBuilderPlanRecord(builderPlanId) {
  return async dispatch => {
    dispatch({
      type: SELECT_BUILDER_PLAN_RECORD,
      data: builderPlanId.toString(),
    });
  };
}

export function selectEconomicUnitRecord(econId) {
  return {
    type: SELECT_ECONOMIC_UNIT_RECORD,
    data: econId.toString(),
  };
}

export function selectEconomicUnitRecordDetails({
  pYear,
  pVersion,
  pRollCorr,
}) {
  return {
    type: SELECT_ECONOMIC_UNIT_RECORD_DETAILS,
    data: { pYear, pVersion, pRollCorr },
  };
}

export function setSidebarMenu(data) {
  return async dispatch => {
    dispatch({ type: SET_SIDEBAR_MENU, data });
  };
}

export function toggleMenu() {
  return async dispatch => {
    dispatch({ type: TOGGLE_MENU });
  };
}

export function selectAssignmentPath(data) {
  return async dispatch => {
    dispatch({ type: SELECT_ASSIGNMENT_PATH, data });
  };
}

export const APPRAISAL_COMPANIES_FETCH = createRequestTypes(
  'GLOBAL/APPRAISAL_COMPANIES_FETCH',
);

export const fetchAppraisalCompanies = makeApiActionCreatorV3(
  api.fetchAppraisalCompanies,
  APPRAISAL_COMPANIES_FETCH[START],
  APPRAISAL_COMPANIES_FETCH[SUCCESS],
  APPRAISAL_COMPANIES_FETCH[ERROR],
);

export const CYCLOMEDIA_CREDENTIALS_FETCH = createRequestTypes(
  'GLOBAL/CYCLOMEDIA_CREDENTIALS_FETCH',
);

export const fetchCyclomediaCredentials = makeApiActionCreatorV3(
  api.fetchCyclomediaCredentials,
  CYCLOMEDIA_CREDENTIALS_FETCH[START],
  CYCLOMEDIA_CREDENTIALS_FETCH[SUCCESS],
  CYCLOMEDIA_CREDENTIALS_FETCH[ERROR],
);

export const FETCH_APPRAISAL_INCOMING_CALLS = createRequestTypes(
  'GLOBAL/FETCH_APPRAISAL_INCOMING_CALLS',
);

export const fetchAppraisalIncomingCalls = makeApiActionCreatorV3(
  api.fetchAppraisalIncomingCalls,
  FETCH_APPRAISAL_INCOMING_CALLS[START],
  FETCH_APPRAISAL_INCOMING_CALLS[SUCCESS],
  FETCH_APPRAISAL_INCOMING_CALLS[ERROR],
);

export const SET_ECON_NAV_DATA = 'APPRAISAL/SET_ECON_NAV_DATA';

export function setEconNavData(data) {
  return async dispatch => {
    dispatch({ type: SET_ECON_NAV_DATA, data });
  };
}
